import { render, staticRenderFns } from "./section-email.vue?vue&type=template&id=3e0a3621&scoped=true&"
import script from "./section-email.vue?vue&type=script&lang=js&"
export * from "./section-email.vue?vue&type=script&lang=js&"
import style0 from "./section-email.vue?vue&type=style&index=0&id=3e0a3621&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a3621",
  null
  
)

export default component.exports